import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import Survey from "../model/Survey";

export const SurveyDetailsApiService = async (request: number): Promise<Survey> => {
  const url = `/forms/${request}/`;
  const { data } = await axios.get(url);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useSurveyDetailsApiService = (id: number, enabled = true) =>
  useQuery<Promise<Survey>, AxiosError, Survey>(
    [ "SurveyDetailsApiService", id], () =>
      SurveyDetailsApiService(id), {
      enabled
    }
  );

export default useSurveyDetailsApiService;